const auth = (state = {}, action) =>
{
	switch (action.type)
	{
		case 'SIGN_IN_SUCCESS':
		{
			const { user } = action.payload;

			return { ...state, user };
		}

		case 'SIGN_OUT_SUCCESS':
		{
			return {};
		}

		case 'UPDATE_ACCOUNT':
		{
			const { user } = action.payload;

			return { ...state, user: { ...state.user, ...user } };
		}

		case 'UPDATE_PLAN':
		{
			const { plan, active } = action.payload;

			return { ...state, user: { ...state.user, plan, planPaused: active } };
		}

		case 'UPDATE_ACTIVE_ROOM':
		{
			const { room } = action.payload;

			return { ...state, user: { ...state.user, room } };
		}

		case 'UPDATE_ADMITTED_STATUS':
		{
			const { admitted } = action.payload;

			return { ...state, user: { ...state.user, admitted } };
		}

		default:
			return state;
	}
};

export default auth;
